import styled from 'styled-components';
import { GridContainer } from '../GridContainer';
/**
 * @deprecated - Please use the LayoutGrid Component from UI Toolkit
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/layoutgrid--docs}
 */
export const SubGrid = styled(GridContainer) `
  align-items: self-start;
  grid-gap: var(--layout-spoon) var(--layout-soybean);
  grid-template-columns: 160px auto;

  & > div {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;

    & > button {
      overflow: hidden;
    }
  }
`;
